// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* EmailModal.module.css */

.gapsy-footer_modalHeader__qA5VV {
  padding: 5px 14px;
  font-size: 13px;
}

.gapsy-footer_modalHeaderColor__WW-oF {
  background-color: #366872;
}

.gapsy-footer_modalTitle__pFu4e {
  font-size: 0.9rem;
}

.gapsy-footer_listGroup__XKZ8d {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}

.gapsy-footer_listGroupItem__ezGc7 {
  cursor: pointer;
  padding: 8px 12px;
  border: 1px solid #366872;
  background-color: #fff;
  transition: background-color 0.2s;
}

.gapsy-footer_listGroupItem__ezGc7:hover {
  background-color: #f8f9fa;
}

.gapsy-footer_link__L\\+7k- {
  text-decoration: none;
  color: inherit;
}

.gapsy-footer_noDocument__wquZi {
  padding: 8px 12px;
  color: #999;
}

.gapsy-footer_borderTop__OC8La {
  border-top: 1px solid #3d405b !important;
}

.gapsy-footer_whiteCloseButton__dvM1T .gapsy-footer_btn-close__TKBlS {
  filter: brightness(0) invert(1);
  margin: auto;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/gapsy-footer.module.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd","sourcesContent":["/* EmailModal.module.css */\r\n\r\n.modalHeader {\r\n  padding: 5px 14px;\r\n  font-size: 13px;\r\n}\r\n\r\n.modalHeaderColor {\r\n  background-color: #366872;\r\n}\r\n\r\n.modalTitle {\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.listGroup {\r\n  list-style: none;\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.listGroupItem {\r\n  cursor: pointer;\r\n  padding: 8px 12px;\r\n  border: 1px solid #366872;\r\n  background-color: #fff;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.listGroupItem:hover {\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.link {\r\n  text-decoration: none;\r\n  color: inherit;\r\n}\r\n\r\n.noDocument {\r\n  padding: 8px 12px;\r\n  color: #999;\r\n}\r\n\r\n.borderTop {\r\n  border-top: 1px solid #3d405b !important;\r\n}\r\n\r\n.whiteCloseButton .btn-close {\r\n  filter: brightness(0) invert(1);\r\n  margin: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalHeader": `gapsy-footer_modalHeader__qA5VV`,
	"modalHeaderColor": `gapsy-footer_modalHeaderColor__WW-oF`,
	"modalTitle": `gapsy-footer_modalTitle__pFu4e`,
	"listGroup": `gapsy-footer_listGroup__XKZ8d`,
	"listGroupItem": `gapsy-footer_listGroupItem__ezGc7`,
	"link": `gapsy-footer_link__L+7k-`,
	"noDocument": `gapsy-footer_noDocument__wquZi`,
	"borderTop": `gapsy-footer_borderTop__OC8La`,
	"whiteCloseButton": `gapsy-footer_whiteCloseButton__dvM1T`,
	"btn-close": `gapsy-footer_btn-close__TKBlS`
};
export default ___CSS_LOADER_EXPORT___;
